import { FunctionComponent } from 'preact';
import './NotificationDropdown.css';
import { NotificationsApiResponse } from '@novelizing/types';
import { CommentOnYourChapterNotification } from '../notification-types/comment-on-your-chapter';
import { ReplyToYourCommentNotification } from '../notification-types/reply-to-your-comment';

export interface NotificationDropdownProps {
  isOpen: boolean;
  notifications: NotificationsApiResponse[];
  onClose: () => void;
  onMarkAsRead: (id: string) => void; // For individual items
  onMarkAllAsRead: () => void; // Button: Mark all as read
  onMarkAsSeen: (id: string) => void; // For individual items (client-side currently)
  onMarkAllAsSeen: () => void; // Button: Mark all as seen
}

export const NotificationDropdown: FunctionComponent<
  NotificationDropdownProps
> = ({
  isOpen,
  notifications,
  onClose,
  onMarkAsRead,
  // onMarkAllAsRead,
  onMarkAsSeen, // Added prop
  // onMarkAllAsSeen, // Added prop
}) => {
  if (!isOpen) return null;

  // const hasUnread = notifications.some((notification) => !notification.isRead);
  // const hasUnseen = notifications.some(
  //   (notification) => !notification.isViewed,
  // );

  return (
    <div className="notification-dropdown">
      <div className="notification-dropdown__header">
        <div className="notification-dropdown__actions">
          <button className="notification-dropdown__close" onClick={onClose}>
            ×
          </button>
          {/* {hasUnread && (
            <button
              className="notification-dropdown__mark-all"
              onClick={onMarkAllAsRead}
            >
              Mark all as read
            </button>
          )} */}
        </div>
      </div>

      <div className="notification-dropdown-content">
        {notifications.length === 0 ? (
          <div className="notification-dropdown__empty">No notifications</div>
        ) : (
          <ul>
            {notifications.map((notification) => (
              <li
                key={notification.id}
                className={`${!notification.isRead ? 'unread' : ''} ${
                  !notification.isViewed ? 'unseen' : ''
                }`}
                onClick={() => {
                  // Mark as seen if not already viewed
                  if (!notification.isViewed) {
                    onMarkAsSeen(notification.id);
                  }
                  // Mark as read if not already read
                  if (!notification.isRead) {
                    onMarkAsRead(notification.id);
                  }
                }}
              >
                {notification.type === 'COMMENT_ON_YOUR_CHAPTER' && (
                  <CommentOnYourChapterNotification
                    notification={notification}
                  />
                )}

                {notification.type === 'REPLY_TO_YOUR_COMMENT' && (
                  <ReplyToYourCommentNotification notification={notification} />
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
